import { Directive, ElementRef, EventEmitter, NgZone, OnDestroy, OnInit, Output } from '@angular/core';

export class ResizedEvent {
    constructor(
        readonly element: ElementRef,
        readonly newWidth: number,
        readonly newHeight: number,
        readonly oldWidth: number,
        readonly oldHeight: number
    ) {}
}

@Directive({
    selector: '[resized]',
    standalone: false
})
export class ResizedDirective implements OnInit, OnDestroy {

    @Output() readonly resized = new EventEmitter<ResizedEvent>();

    private observer: ResizeObserver;
    private oldWidth: number;
    private oldHeight: number;

    constructor(private element: ElementRef<HTMLElement>, private zone: NgZone) {}

    ngOnInit() {
        this.observer = new ResizeObserver(() => this.zone.run(() => this.onResized()));
        this.observer.observe(this.element.nativeElement);
    }

    ngOnDestroy() {
        this.observer?.disconnect();
    }

    private onResized() {
        const newWidth = this.element.nativeElement.clientWidth;
        const newHeight = this.element.nativeElement.clientHeight;
        if (newWidth === this.oldWidth && newHeight === this.oldHeight) {
            return;
        }
        const event = new ResizedEvent(this.element, newWidth, newHeight, this.oldWidth, this.oldHeight);
        this.oldWidth = newWidth;
        this.oldHeight = newHeight;
        this.resized.emit(event);
    }
}
